import React from 'react';

import './activity-indicator.scss';

export default class ActivityIndicator extends React.Component {
    render() {
        const { visible } = this.props;

        if ( visible ) {
            return (
                <div className="activity-indicator" ref={ this.beginAnimation } >
                    <svg className="spinner" viewBox="0 0 66 66">
                        <g>
                            <circle className="path1" cx="33" cy="33" r="30"></circle>
                            <circle className="path2" cx="33" cy="33" r="30"></circle>
                        </g>
                    </svg>
                    <span />
                </div>
            );
        } else {
            return null;
        }
    }

    beginAnimation = ( element ) => {
        if ( element ) {

            const svg = element.childNodes[ 0 ];
            const group = svg.childNodes[ 0 ];
            const circle1 = group.childNodes[ 0 ];
            const circle2 = group.childNodes[ 1 ];

            const now = window.performance ? window.performance.now() : new Date().valueOf();
            const duration = 1400.00;
            const offset = 187.00;

            const animate = () => {
                const percent = ( ( ( window.performance ? window.performance.now() : new Date().valueOf() - now ) / duration ) % 1 ) ;

                const groupRoteate = percent * 270;
                group.setAttribute( 'transform', 'rotate(' + groupRoteate.toString() + ', 33, 33)' );

                const strokeDashoffset = ( Math.abs( percent - .5 ) / .5 ) * ( offset - ( offset / 4 ) ) + ( offset / 4 );
                circle1.style.strokeDashoffset = strokeDashoffset;
                circle2.style.strokeDashoffset = strokeDashoffset;

                const strokeOpacity = percent;
                circle1.style.opacity = strokeOpacity;
                circle2.style.opacity = 1 - strokeOpacity;

                const strokeRotate = percent * 450;
                circle1.setAttribute( 'transform', 'rotate(' + strokeRotate.toString() + ', 33, 33)' );
                circle2.setAttribute( 'transform', 'rotate(' + strokeRotate.toString() + ', 33, 33)' );

                window.requestAnimationFrame( animate );
            };

            if ( typeof window.requestAnimationFrame === 'function' ) {
                animate();
            }
        }
    }
}